import { apiClient } from '@/lib/api'

const BASE_URL = '/v1/buyers'

/**
 * Buyers API Client
 * Handles all API calls for buyers management
 */
export const buyersApi = {
  /**
   * Get all buyers with pagination and filters
   */
  getAll: async (params = {}) => {
    const response = await apiClient.get(BASE_URL, { params })
    return response.data
  },

  /**
   * Get buyer by ID
   */
  getById: async (id) => {
    const response = await apiClient.get(`${BASE_URL}/${id}`)
    return response.data
  },

  /**
   * Create new buyer
   */
  create: async (data) => {
    const response = await apiClient.post(BASE_URL, data)
    return response.data
  },

  /**
   * Update buyer (full update)
   */
  update: async (id, data) => {
    const response = await apiClient.put(`${BASE_URL}/${id}`, data)
    return response.data
  },

  /**
   * Partial update buyer
   */
  partialUpdate: async (id, data) => {
    const response = await apiClient.patch(`${BASE_URL}/${id}`, data)
    return response.data
  },

  /**
   * Delete buyer (soft delete)
   */
  delete: async (id) => {
    const response = await apiClient.delete(`${BASE_URL}/${id}`)
    return response.data
  },

  /**
   * Autocomplete search for buyers
   */
  getAutocomplete: async ({ search = '', page = 1, page_size = 20 }) => {
    const params = {
      search,
      page,
      page_size,
    }
    const response = await apiClient.get(BASE_URL, { params })
    return response
  },
}
